module.exports = __webpack_public_path__ + "img/2ab.33d067e3.png";